import { MystiqueEnvironmentHost, StargateEnvironmentHost, isStagingEnvironment } from "waapi/environments-repository/constants/environments.js";
import { buildIsKnownHostEntry } from "waapi/environments-repository/helpers/isKnownHost.js";
import { ENVIRONMENT_HOSTS, ENVIRONMENT_HOSTS_STARGATE } from "../../../config/environment/constants.js";

const isKnownHost = buildIsKnownHostEntry(ENVIRONMENT_HOSTS);

export const buildTranslationsLoadPath = ({ fragment, pathSuffix = "" }: { fragment: string; pathSuffix?: string }): string => {
    const { host } = window.location;
    const validHost = isKnownHost(host) ? host : MystiqueEnvironmentHost.PROD;

    if (isStagingEnvironment(ENVIRONMENT_HOSTS[validHost])) {
        return `https://${ENVIRONMENT_HOSTS_STARGATE[validHost]}/api/shakespeare/translations${pathSuffix}?fragment=${fragment}&language={{lng}}`;
    }

    return `https://${StargateEnvironmentHost.PROD}/api/shakespeare/translations${pathSuffix}?fragment=${fragment}&language={{lng}}`;
};
